import { QueryHandlingService } from '@akebono/core';
import { Injectable } from '@angular/core';
import { map, shareReplay } from 'rxjs/operators';
import { LotData } from 'src/app/const';
import { imageExtensionsSet } from 'src/app/constants/image-exntensions';
import { videoExtensionsSet } from 'src/app/constants/video-extensions';
import { ServiceRequestAuctionLotByUserGQL } from 'src/app/modules/graphql/service/graphql-shared-familiar-service';

import { LotWatchRequestInspectionFetchRef } from './types/lot-watch-request-fetch-ref.type';
import { LotWatchRequestFiles } from './types/lot-watch-request-files.type';
import { LotWatchRequestInspectionData } from './types/lot-watch-request-inspection-data.type';

@Injectable()
export class AuctionVideoWatchService {
  constructor(
    private readonly qhs: QueryHandlingService,
    private readonly serviceRequestAuctionLotByUserGQL: ServiceRequestAuctionLotByUserGQL,
  ) {}

  fetchInspection(lotData: LotData): LotWatchRequestInspectionFetchRef {
    const queryRef = this.qhs.watch(
      this.serviceRequestAuctionLotByUserGQL,
      {
        lotId: lotData.lot.id,
        lotSource: lotData.lotSource,
        lotSubgroup: lotData.lotType,
      },
      'network-only',
    );

    const loading$ = queryRef.loading;
    const inspection$ = queryRef.data.pipe(
      map((result) => {
        const requestUserData = result?.serviceRequestAuctionLotByUser;

        const files = requestUserData?.files ?? [];
        const urls = files?.map((file) => file?.fullPathForFile);
        const filesByType = this.separateFilesByType(urls);
        const downloadAllUrl =
          urls
            .slice()
            .reverse()
            .find((u) => u.toLowerCase().endsWith('.zip')) ?? null;

        return <LotWatchRequestInspectionData>{
          downloadAllUrl,
          inspectionFiles: filesByType,
          requestCompleted: filesByType.images.length > 0 || filesByType.videos.length > 0,
          requestExists: !!requestUserData,
          isForCurrentUser: requestUserData?.isForCurrentUser ?? false,
        };
      }),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    return {
      loading$,
      inspection$,
    };
  }

  private separateFilesByType(files: string[]): LotWatchRequestFiles {
    return files.reduce(
      (acc, file) => {
        const extension = file.split('.').pop().toLowerCase();
        if (videoExtensionsSet.has(extension)) {
          acc.videos.push(file);
        } else if (imageExtensionsSet.has(extension)) {
          acc.images.push(file);
        }

        return acc;
      },
      { images: [], videos: [] } as LotWatchRequestFiles,
    );
  }
}
